import {
  HttpErrorResponse,
  HttpInterceptorFn
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const _router: Router = inject(Router);

  return next(req).pipe(
    catchError((response: HttpErrorResponse) => {
      let errors: string[] | null = null;
      console.log(response)

      if (response.status === 0 || response.status === 502) {
      }

      if (response.status === 401) {
        _router.navigateByUrl('/Login');
        errors = ['La sesión ha expirado.'];
      } else if (Array.isArray(response.error?.exceptions)) {
        errors = response.error['exceptions'];
      } else if (Array.isArray(response.error?.errors?.exceptions)) {
        errors = response.error?.errors?.exceptions;
      }
      else if (response.error?.type === 'DomainException') {
        errors = [response.error?.detail];
      }

      if (errors == null || errors.length === 0) {
        errors = ['Se ha producido un error al comunicarse con la plataforma.'];
      }

      // Retornar el error capturado
      return throwError(() => errors);
    })
  );
};
